import { getApiBaseUrl } from 'helpers/api';
import axiosInstance from 'utils/axiosInstance';

const baseUrl = getApiBaseUrl();

export const searchPolicy = (data: any) =>
  axiosInstance.post(`${baseUrl}/policies/search`, data);
